import { LocalesEnum, RegionsEnum } from '../generated/operations';

// @TODO query from config
export const getDefaultLocale = (region: RegionsEnum): LocalesEnum => (region === RegionsEnum.Am
    ? LocalesEnum.EnUs
    : LocalesEnum.EnGb
);
